import { useEnvStore } from '@gik/core/store/EnvStore';

export function usePgDesignUploader() {
  const useDesignUploader = useEnvStore(state => state.PG_USE_DESIGN_UPLOADER);
  return useDesignUploader === 'true';
}
